// Phase 0: Frontend feature flags (no functional changes)
// Reads from environment variable REACT_APP_FEATURE_WORKFLOW_DOC_GROUPS
// Defaults to false when not provided.

const toBool = (val) => {
  if (typeof val === "boolean") return val;
  if (typeof val === "string") {
    const v = val.trim().toLowerCase();
    return v === "true" || v === "1" || v === "yes";
  }
  if (typeof val === "number") return val !== 0;
  return false;
};

export const FEATURE_WORKFLOW_DOC_GROUPS = toBool(
  process.env.REACT_APP_FEATURE_WORKFLOW_DOC_GROUPS
);

// UI-only flags to control visibility of grouped documents panel (Phase 2A)
// and selection state + preview (Phase 3A) independently of backend plumbing.
export const FEATURE_WORKFLOW_DOC_GROUPS_UI = toBool(
  process.env.REACT_APP_FEATURE_WORKFLOW_DOC_GROUPS_UI
);

export const FEATURE_WORKFLOW_DOC_SELECTIONS = toBool(
  process.env.REACT_APP_FEATURE_WORKFLOW_DOC_SELECTIONS
);

// Organization Document feature flags (UI-First approach)
// Toggle mock data on/off during development
export const ORG_DOC_USE_MOCK_DATA = toBool(
  process.env.REACT_APP_ORG_DOC_USE_MOCK_DATA ?? true
);

// Show [MOCK] badge in UI when using mock data
export const ORG_DOC_SHOW_MOCK_BADGE = toBool(
  process.env.REACT_APP_ORG_DOC_SHOW_MOCK_BADGE ?? true
);

// Enable document extraction feature (AI-powered)
export const ORG_DOC_ENABLE_EXTRACTION = toBool(
  process.env.REACT_APP_ORG_DOC_ENABLE_EXTRACTION ?? true
);

// Enable tax profile auto-update from extracted documents
export const ORG_DOC_ENABLE_TAX_PROFILE = toBool(
  process.env.REACT_APP_ORG_DOC_ENABLE_TAX_PROFILE ?? true
);

export default {
  FEATURE_WORKFLOW_DOC_GROUPS,
  FEATURE_WORKFLOW_DOC_GROUPS_UI,
  FEATURE_WORKFLOW_DOC_SELECTIONS,
  ORG_DOC_USE_MOCK_DATA,
  ORG_DOC_SHOW_MOCK_BADGE,
  ORG_DOC_ENABLE_EXTRACTION,
  ORG_DOC_ENABLE_TAX_PROFILE,
};
